<template>
  <div class="cp-customizations-display" v-if="hasCartProductCustomizations">
    {{ t('cart_product_customizations.prefix_label') }}: <br>
    <ul
      v-for="(group, groupKey) in cartProductCustomizations.groups"
      :key="groupKey"
    >
      <li
        v-for="(item, itemKey) in group.items"
        :key="`${groupKey}/${itemKey}`"
      >{{ item.value || '' }}</li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'AdvCartProductCustomizationDisplayValues',
  props: {
    product: {
      type: Object,
      required: true
    }
  },
  computed: {
    hasCartProductCustomizations () {
      const check = ('options' in this.product) &&
        ('cartProductCustomizations' in this.product.options) &&
        ('groups' in this.product.options.cartProductCustomizations) &&
        (this.product.options.cartProductCustomizations.groups.length > 0)

      if (!check) {
        return false
      }

      if (
        '_meta' in this.product.options.cartProductCustomizations &&
        'isModified' in this.product.options.cartProductCustomizations._meta
      ) {
        return this.product.options.cartProductCustomizations._meta.isModified
      }

      return true
    },
    cartProductCustomizations () {
      if (!this.hasCartProductCustomizations) {
        return {
          groups: []
        }
      }

      return this.product.options.cartProductCustomizations
    }
  }
}
</script>

<style lang="scss" scoped>
.cp-customizations-display {
  font-size: 0.8rem;
  color: #666;
  font-weight: 900;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(145px, 1fr));
  width: 100%;
  justify-content: flex-start;
  align-content: center;
  grid-gap: 0.25rem;

  ul {
    list-style-type: none;
    display: inline-flex;
    justify-content: flex-start;
    grid-gap: 0.25rem;
    overflow: auto;
    padding: 0;
  }
}
</style>
